// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { DragomanLocalesAPIResponse } from '../types/dragoman';

const { REACT_APP_DRAGOMAN_API_URL } = process.env;

// Define a service using a base URL and expected endpoints
export const dragomanApi = createApi({
  reducerPath: 'dragomanApi',
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_DRAGOMAN_API_URL,
  }),
  endpoints: (builder) => ({
    getGryphonLocales: builder.query<DragomanLocalesAPIResponse, void>({
      query: () => `/app/gryphon`,
      transformResponse: (response: any): any => {
        return {
          ...response,
          languages: [...response.languages].sort((a, b) => (a.name > b.name ? 1 : -1)),
        };
      },
    }),
    getDragomanLanguages: builder.query<DragomanLocalesAPIResponse, void>({
      query: () => `/language`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetGryphonLocalesQuery, useGetDragomanLanguagesQuery } = dragomanApi;
